import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section aria-labelledby="garantia-titulo" className="w-full bg-white py-14 sm:py-16" data-id="element-116" data-mp="1o3x1pk7r0m0y">
      <div className="mx-auto max-w-3xl px-5" data-id="element-117" data-mp="22369pwlsw9tu">
        <div className="flex flex-col items-center gap-5 rounded-3xl border-2 border-dashed border-gold bg-cream p-7 text-center sm:p-10" data-id="element-118" data-mp="222wh019dfokg">
          <span className="flex h-16 w-16 items-center justify-center rounded-full bg-gold" data-id="element-119" data-mp="19eqwnfm8c1l5">
            <ShieldCheckIcon className="h-8 w-8 text-navy-deep" aria-hidden="true" data-id="element-120" data-mp="19ceep2gh1r83" />
          </span>

          <h2 id="garantia-titulo" className="font-display text-2xl font-extrabold text-navy text-balance sm:text-3xl" data-id="element-121" data-mp="1j4k72damyant">
            🛡️ Garantía 7 días — sin preguntas, sin drama
          </h2>

          <div className="space-y-4 text-base leading-relaxed text-navy/80" data-id="element-122" data-mp="qnhlz30q36rz">
            <p data-id="element-123" data-mp="lpg3aj77l9h1">
              Descargás los tomos. Los usás con tu hijo/a o en tu aula. Si en 7 días no es
              exactamente lo que esperabas —{' '}
              <strong className="font-extrabold text-navy" data-id="element-124" data-mp="oz02jss8lwn9">
                te devolvemos el 100% del dinero
              </strong>
              . Sin formularios. Sin explicaciones. Sin demoras.
            </p>
            <p className="font-bold text-navy" data-id="element-125" data-mp="yrfmgvn3gvas">
              Podemos ofrecer esa garantía porque sabemos lo que tenemos.
            </p>
          </div>

          <p className="rounded-full bg-navy px-4 py-2 text-sm font-bold text-white" data-id="element-126" data-mp="61fh6voolg7e">
            Tasa de devoluciones: menos del 1%.
          </p>
        </div>
      </div>
    </section>;
}